import React from "react";

const ModalXButton = () => {
  return (
    <svg
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7175 19.1523L14.7151 14.1499L19.7175 9.14747C19.945 8.92003 20.0727 8.61156 20.0727 8.28991C20.0727 7.96827 19.945 7.6598 19.7175 7.43236C19.4901 7.20492 19.1816 7.07715 18.86 7.07715C18.5383 7.07715 18.2298 7.20492 18.0024 7.43236L13 12.4348L7.99759 7.43236C7.77016 7.20492 7.46169 7.07715 7.14004 7.07715C6.81839 7.07715 6.50992 7.20492 6.28249 7.43236C6.05505 7.6598 5.92727 7.96827 5.92727 8.28991C5.92728 8.61156 6.05505 8.92003 6.28249 9.14747L11.2849 14.1499L6.28249 19.1523C6.05505 19.3797 5.92727 19.6882 5.92727 20.0098C5.92727 20.3315 6.05505 20.6399 6.28249 20.8674C6.50992 21.0948 6.81839 21.2226 7.14004 21.2226C7.46169 21.2226 7.77016 21.0948 7.9976 20.8674L13 15.865L18.0024 20.8674C18.2298 21.0948 18.5383 21.2226 18.86 21.2226C19.1816 21.2226 19.4901 21.0948 19.7175 20.8674C19.945 20.6399 20.0727 20.3315 20.0727 20.0098C20.0727 19.6882 19.945 19.3797 19.7175 19.1523Z"
        fill="black"
      />
    </svg>
  );
};

export default ModalXButton;
